import { styled } from "@linaria/react";
import { isMobile } from "../../../@css-style";
import { css } from "@linaria/core";

export const ElNavigation = styled.nav`
  width: 100%;
  display: flex;
  padding: 10px;
  position: sticky;
  top: 0;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
  z-index: 999999;
  background-color: #fff;
`;

export const ElNavigationContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const EllogoLink = styled.a``;
export const EllogoImg = styled.img`
  height: 45px;
  width: auto;
`;

export const ElMenu = styled.ul`
  /* width: 100%; */
  display: flex;
  padding: 0;
  gap: 30px;
`;

export const elIsMobile = css`
  ${String(isMobile)} {
    display: none !important;
  }
`;

export const ElMenuDrop = styled.div`
  /* width: 100%; */
  display: none;
  padding: 0;
  gap: 30px;
  ${String(isMobile)} {
    display: flex;
  }
`;

export const elAnchor = css`
  /* display: flex; */

  font-size: 14px;
  color: var(--theme-main-flat-dark-color);
  padding: 15px 0;
  transition: all 0.4s ease;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;

  &:hover {
    color: var(--theme-main-green-color);
  }
`;
export const ElDropMenu = styled.div`
  display: none;
  position: absolute;
  flex-direction: column;
  padding: 0 15px;
  top: 40px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  min-width: 150px;
  ${elAnchor} {
    &:hover {
      opacity: 0.7;
    }
  }
`;
export const ElMenuItem = styled.li`
  display: flex;
  position: relative;

  &:hover {
    ${ElDropMenu} {
      display: flex;
    }
    ${ElDropMenu} {
      display: flex;
    }
  }
`;

export const ElMenuMobile = styled.ul`
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 10px;
  ${ElMenuItem} {
    flex-direction: column;
  }
  ${ElDropMenu} {
    position: relative;
    top: 0;
  }
`;
export const elAnchorButton = css`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--theme-main-flat-color);
  border: 1px solid var(--theme-main-green-color);
  background-color: var(--theme-main-green-color);
  transition: all 0.4s ease;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  padding: 12px 24px;
  border-radius: 3px;
  ${String(isMobile)} {
    padding: 8px 12px;
    font-size: 12px;
  }
  &:hover {
    color: var(--theme-main-green-color);
    background-color: var(--theme-main-flat-color);
  }
`;

export const elactive = css`
  color: var(--theme-main-green-color);
  * {
    color: var(--theme-main-green-color);
  }
`;
